import React, { useCallback } from 'react';
import { Mixpanel, UseMixpanelProps } from '@treatwell/ui';
import { StateData } from 'js/model/rainbow/StateData';
import { getDeviceId } from '@treatwell/growthbook-js';
import { useGrowthBook } from '@growthbook/growthbook-react';
import { isProductionEnvironment } from '../helpers/environment';

export const MixpanelContainer = ({ pageData }: { pageData: StateData }) => {
  const shouldLoadMixpanel = /homepage|browse/.test(pageData.pageType);
  const gb = useGrowthBook();
  const mixpanelProps: UseMixpanelProps = {
    isProduction: isProductionEnvironment,
    channelCode: pageData.channel.code,
    getMixpanelFlagValues: useCallback(() => {
      return gb.getFeatureValue('ff-web-frontend__mixpanel-recording', []);
    }, [gb]),
    getExperimentValue: useCallback(
      (experimentName) => {
        return gb.getFeatureValue(experimentName, 'none');
      },
      [gb]
    ),
    getTrackingDeviceId: useCallback(() => {
      return getDeviceId();
    }, []),
  };

  return shouldLoadMixpanel ? <Mixpanel {...mixpanelProps} /> : null;
};
